/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatCategoryItem.vue?vue&type=template&id=2bd4ca80"
import script from "./ChatCategoryItem.vue?vue&type=script&lang=js"
export * from "./ChatCategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd4ca80')) {
      api.createRecord('2bd4ca80', component.options)
    } else {
      api.reload('2bd4ca80', component.options)
    }
    module.hot.accept("./ChatCategoryItem.vue?vue&type=template&id=2bd4ca80", function () {
      api.rerender('2bd4ca80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatCategoryItem.vue"
export default component.exports